<template>
  <div class="main-content">
    <div class="p-4 mx-5">
      <div class="row">
        <div
          class="col-lg-4 col-md-4 mb-4 col-12"
          v-for="(item, i) in info"
          :key="i"
        >
          <div class="d-inline-block w-100 text-center card_main">
            <div
              class="cardMain_content position-relative"
              :class="check(item) ? 'progress_cardAfter' : ''"
            >
              <div class="card_header position-relative p-2">
                <div class="header_icon">
                  <img
                    v-if="item.type == 'WSL'"
                    src="/weapsmithing/images/material_leather.png"
                    alt=""
                    class="img-fluid inner_icon"
                  />
                  <img
                    v-if="item.type == 'WSW'"
                    src="/weapsmithing/images/material_wood.png"
                    alt=""
                    class="img-fluid inner_icon"
                  />
                  <img
                    v-if="item.type == 'WSM'"
                    src="/weapsmithing/images/material_MetalBar.png"
                    alt=""
                    class="img-fluid inner_icon progressbarIcon"
                  />
                </div>
                <div class="w-100 text-uppercase">
                  <h3 class="m-0" v-if="item.type == 'WSL'">Hunting</h3>
                  <h3 class="m-0" v-if="item.type == 'WSW'">Wood Cutting</h3>
                  <h3 class="m-0" v-if="item.type == 'WSM'">Ore mining</h3>
                </div>
                <div class="header_icon header_right">
                  <h3 class="inner_icon">{{ item.reward }}</h3>
                </div>
              </div>
              <div class="card_content position-relative">
                <div class="cardInner_content p-3">
                  <img
                    v-if="item.type == 'WSL'"
                    src="/weapsmithing/images/skinning-animal-scene.png"
                    alt="image"
                    class="img-fluid mb-2"
                  />
                  <img
                    v-if="item.type == 'WSW'"
                    src="/weapsmithing/images/cutting-tree-scene-2.png"
                    alt="image"
                    class="img-fluid mb-2"
                  />
                  <img
                    v-if="item.type == 'WSM'"
                    src="/weapsmithing/images/mining-scene-1.png"
                    alt="image"
                    class="img-fluid mb-2"
                  />
                  <div class="content_text">
                    <label class="text-uppercase d-block m-0"
                      >Requirements</label
                    >
                    <span>Can be accepted with {{ item.rarity }} weapons</span>
                  </div>
                </div>
              </div>
              <div
                class="content_label"
                :class="
                  check(item) ? 'progressContent_label position-relative' : ''
                "
              >
                <label class="text-capitalize">{{ item.rarity }}</label>
              </div>
            </div>
            <div class="card_btn" v-if="!check(item)">
              <a href="#" @click="acceptOpenModal(item)">Accept</a>
            </div>
            <div
              class="card_btn btn_orange"
              v-if="check(item) && !showClaim(item)"
            >
              <a href="#">
                <Countdown
                  :deadline="timeLeft(item)"
                  countdownSize="1.1rem"
                  labelSize="0.6rem"
                  :showDays="false"
                  :showLabels="false"
                  :mainColor="`#fff`"
                  :flipAnimation="false"
                />
              </a>
            </div>
            <div class="card_btn" v-if="showClaim(item)">
              <a href="#" @click="claimMission(item)"> Claim </a>
            </div>
          </div>
        </div>

        <!-- in progress -->

        <!-- <div class="col-lg-4 col-md-4 col-12">
          <div class="d-inline-block w-100 text-center card_main" >
            <div class="cardMain_content position-relative progress_cardAfter">
              <div class="card_header position-relative p-2">
                <div class="header_icon progressIcon_border">
                  
                </div>
                <div class="w-100 text-uppercase">
                  
                </div>
                <div class="header_icon header_right progressIcon_border">
                  <h3 class="inner_icon progressbarIcon">50</h3>
                </div>
              </div>
              <div class="card_content">
                <div class="cardInner_content p-3 position-relative">
                  
                  <div class="content_text">
                    <label class="text-uppercase d-block m-0">Requirements</label>
                    <span>Can be accepted with Uncommon weapons and above</span>
                  </div>
                  <div class="inprogressText position-absolute">
                    <h2 class="text-uppercase">in progress</h2>
                  </div>
                </div>
              </div>
            </div>
            <div class="content_label progressContent_label position-relative">
              <label class="text_green">Uncommon</label>
            </div>
            <div class="card_btn btn_orange">
              <a href="#">2h:59m</a>
            </div>
          </div>
        </div> -->

        <!--End in progress  -->
      </div>
    </div>
    <SelectWeaponModal
      v-on:w-modal-hide-click="isShowModal = false"
      v-if="isShowModal"
      :item="selectedMissionItem"
    />
  </div>
</template>

<script>
import SelectWeaponModal from "../components/SelectWeaponModal.vue";
// @ is an alias to /src
// import router from "@/router";
import ApiService from "@/services";
import { useToast } from "vue-toastification";
const toast = useToast();
import moment from "moment";
import { Countdown } from "vue3-flip-countdown";
export default {
  name: "Mission",
  components: {
    SelectWeaponModal,
    Countdown,
  },
  data() {
    return {
      isShowModal: false,
      info: [],
      selectedMissionItem: null,
    };
  },
  created() {
    ApiService.getTableContract("mission", null, (response) => {
      this.info = response.rows.map((res) => {
        var amount = parseFloat(res.reward);
        var currency = res.reward.replace(/[\d., ]/g, "");
        return {
          reward: amount,
          id: res.id,
          type: currency,
          active: res.active,
          rarity: res.rarity,
          cooldown: res.cooldown,
          expired: res.expire_after,
          onMission: res.on_mission.filter(
            (x) => x.key == localStorage.getItem("wax_user")
          ),
        };
      }).filter(res => res.active == 1 || res.onMission.length)
    });
  },
  mounted() {
    this.info.filter(res => res.active == 1);
    this.$store.dispatch("getWeapons");
  },
  methods: {
    check(mission) {
      if (mission.onMission.length > 0) {
        return true;
      }
      return false;
    },
    showClaim(mission) {
      if (mission.onMission.length > 0) {
        const cooldown = moment(
          mission.onMission[0].value.cooldown_until + "+00:00"
        )
          .local()
          .format("YYYY-MM-DD HH:mm:ss");
        const finish = moment
          .duration(moment(cooldown).diff(moment()))
          .asHours();
        return !(finish > 0);
      }
      return false;
    },
    timeLeft(mission) {
      if (mission.onMission.length > 0) {
        return moment(mission.onMission[0].value.cooldown_until + "+00:00")
          .local()
          .format("YYYY-MM-DD HH:mm:ss");
      }
    },
    acceptOpenModal(item) {
      this.isShowModal = true;
      this.selectedMissionItem = item;
    },
    claimMission(selectedMissionItem) {
      ApiService.transaction(
        {
          contract: process.env.VUE_APP_CONTRACT,
          action: "claim.missn",
          data: {
            account: localStorage.getItem("wax_user"),
            mission_id: selectedMissionItem.id,
          },
        },
        (res) => {
          if (res.processed) {
            toast.success("Transaction Successful");
            setTimeout(() => {
              this.$router.go();
            }, 2000);
          }
        }
      );
    },
  },
};
</script>
<style scoped>
.header_icon {
  border: 6px solid #273c75;
  border-radius: 100px;
  position: absolute;
  left: -15px;
  top: -10px;
  width: 65px;
  height: 65px;
  z-index: 2;
}
.header_icon .inner_icon {
  background-color: #487eb0;
  border-radius: 100px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.header_right {
  left: inherit;
  right: -15px;
}
.card_header {
  background-color: #344b7d;
  width: 95%;
  margin: 0 auto;
}
.card_content {
  background-color: rgba(78, 113, 141, 0.9);
  width: 95%;
  margin: 0 auto;
}
.cardInner_content img {
  width: 300px;
}
.content_text label {
  font-family: JockeyOne !important;
  color: var(--main-white);
}
.content_text span {
  font-size: 14px;
}
.content_label {
  background-color: #2b4170;
  font-family: JockeyOne !important;
  color: #ebf97e;
  padding: 8px 15px;
  border-radius: 10px;
  box-shadow: 0px 10px 10px -7px #5b5b5b;
}
.card_btn a {
  padding: 6px 50px;
  margin-top: 10px;
  font-family: JockeyOne !important;
  display: inline-block;
  background: #4bd037;
  color: #fff;
  border-radius: 10px;
  font-size: 20px;
  box-shadow: 0px 3px 5px 0px #535353;
  text-transform: uppercase;
}
.cardInner_content {
  min-height: 360px;
}
/* in progress */

.progressIcon_border {
  border: 6px solid rgba(105, 156, 149, 0.7);
}
.progressbarIcon {
  background-color: rgba(60, 99, 142, 0.7) !important;
  webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
}
.progress_cardAfter::after {
  content: "";
  background-color: rgba(86, 136, 137, 0.7);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 95%;
  margin: 0 auto;
  border-radius: 10px 10px 0 0;
}
.progressContent_label {
  background-color: rgba(59, 93, 121, 0.4) !important;
}
.progressContent_label::after {
  content: "";
  background-color: rgba(86, 136, 137, 0.7);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  border-radius: 10px;
  z-index: 1;
}
.text_green {
  color: #20cc68;
  position: relative;
  z-index: 2;
}
.btn_orange a {
  background-color: #e84218;
}
.progress_cardAfter .card_header {
  border-radius: 10px 10px 0 0;
}
.inprogressText {
  top: 35%;
  left: 0;
  z-index: 4;
  width: 100%;
}

/* End in progress */
</style>